import React, {useCallback} from 'react';

export const ArdMenuHandle = ({handleMenuToggleClicked, showMenu, id}) => {
  const handleClick = useCallback(
    event => {
      handleMenuToggleClicked(event);
    },
    [handleMenuToggleClicked]
  );
  return (
    <input
      style={{cursor: 'pointer'}}
      type='checkbox'
      checked={showMenu}
      readOnly={true}
      tabIndex='-1'
      className='item-menu-toggle'
      onClick={handleClick}
      id={id}
    />
  );
};
export default ArdMenuHandle;
